<template>
  <vs-row class="mt-3 pt-3" style="border-top: 1px solid #cdcdcd;">
    <div>
      <vs-checkbox v-for="company in companyTree"  v-model="companies" :vs-value="company.descendant_id">{{ company.descendant.com_name }}</vs-checkbox>
    </div>
  </vs-row>
</template>

<script>
export default {
  name: 'SearchNavItemTartgets',
  props: {
    value: Array,
  },
  watch: {
    companies: {
      immediate: true,
      handler() {
        this.$emit('input', this.companies)
      }
    }
  },
  computed: {
    companyTree () {
      console.log("this.$store.state.company.companyTree", this.$store.state.company.companyTree)
      return this.$store.state.company.companyTree
    }
  },
  data () {
    return {
      companies: [],
    }
  }

}
</script>

<style scoped>

</style>
